export default "__VITE_ASSET__DHT4S8Zx__"